import React from 'react';
import { Typography } from '@mui/material';

const DisplayHTML: React.FC<{ content: string }> = ({ content }) => {
  return <Typography dangerouslySetInnerHTML={{ __html: content }} />;
};

export default DisplayHTML;
